import { ListDto } from "../types/dto";
import { ApiService } from "./apiService";


export const getTeamInvitationsRequests = async (dto: ListDto) => {
    return await ApiService.get(`invitations/requests?page=${dto.page}&size=${dto.size}`)
}

export const approveTeamInvitationRequest = async (requestId: string) => {
    return await ApiService.post(`invitations/requests/${requestId}/approve`, {});
}

export const rejectTeamInvitationRequest = async (requestId: string) => {
    return await ApiService.post(`invitations/requests/${requestId}/reject`, {});
}